// extracted by mini-css-extract-plugin
export default {"page-container":"Pagination_page-container__9Y+Qh","icon-left":"Pagination_icon-left__CK4L3","icon-right":"Pagination_icon-right__ng3Xk"};